import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/core/assets/illustrations/illustration-delete.svg'


const _withScopeId = n => (_pushScopeId("data-v-44f50e8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "delete",
  class: "header"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Delete this synonym?"),
  /*#__PURE__*/_createElementVNode("div", null, " Deleting this synonym will remove it permanently. This action cannot be undone. ")
], -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Confirm Delete ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    onConfirm: _ctx.deleteSynonym,
    onClose: _ctx.close,
    "main-button-color": "var(--color-warning)"
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _hoisted_2
    ]),
    "button-content": _withCtx(() => [
      _hoisted_3
    ]),
    _: 1
  }, 8, ["onConfirm", "onClose"]))
}